<template>
	<!--步骤条-->
  <div class="slide k-slide">
    <div class="k-slide-con">
      <div class="k-slide-nav" :style="{ width: slidewidth + 'px' }">
        <el-menu ref="menu" :unique-opened="false" :router="true" :default-active="defaultActive">
          <template v-for="val in info.clickMenus">
                <el-menu-item :key="val.menu_url" :index="val.menu_url" v-if="val.is_show == 'YES'">
                    <i :class="val.menu_icon"></i>
                    <span slot="title">{{val.menu_name}}</span>
                </el-menu-item>
          </template>
		  <!-- <el-menu-item index="/department">
		    <i></i>
		    <span slot="title">部门管理</span>
		  </el-menu-item>
		  <el-menu-item index="/users">
		    <i></i>
		    <span slot="title">用户管理</span>
		  </el-menu-item>
		  <el-menu-item index="/groups">
		    <i></i>
		    <span slot="title">用户组管理</span>
		  </el-menu-item>
		  <el-menu-item index="/menus">
		    <i></i>
		    <span slot="title">菜单管理</span>
		  </el-menu-item>
		  <el-menu-item index="/actions">
		    <i></i>
		    <span slot="title">功能管理</span>
		  </el-menu-item> -->
        </el-menu>
      </div>
      <div class="k-slide-button">
        <i :class="activeClass" @click="toggleNav()"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slide',
  props: ['info'],
  data() {
    return {
      slidewidth: 180,
      activeClass: 'el-icon-s-fold'
    }
  },
  computed: {
    defaultActive: function() {
      return this.$route.path ? this.$route.path : '/'
    }
  },
  methods: {
    toggleNav: function() {
      this.isCollapse = !this.isCollapse
      if (this.isCollapse) {
        this.activeClass = 'el-icon-s-unfold'
        this.slidewidth = 38
      } else {
        this.activeClass = 'el-icon-s-fold'
        this.slidewidth = 180
      }
    }
  }
}
</script>
<style scoped>
.k-slide-con {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border-right: 1px solid #e8eaec;
  background-color: #fff;
}
.k-slide-con .el-menu {
  border-right: none !important;
}
.k-slide-con .k-slide-nav {
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  width: 180px;
}
.k-slide-con .k-slide-nav .el-menu-item {
  padding-left: 8px !important;
}
.k-slide-con .k-slide-button {
  height: 40px;
  margin-right: 6px;
  line-height: 40px;
  color: #979797;
  text-align: right;
  font-size: 16px;
}
.k-slide-con .k-slide-button i {
  cursor: pointer;
}

</style>
